import type { ReactNode } from 'react';
import { cx } from '../../componentes/ui';
import base from './publico.module.css';

/** Sobretítulo + título + introdução: a abertura de toda seção da landing. */
export function CabecalhoSecao({
  sobretitulo,
  titulo,
  children,
  centro,
  className,
}: {
  sobretitulo: string;
  titulo: ReactNode;
  children?: ReactNode;
  centro?: boolean;
  className?: string;
}) {
  return (
    <div className={cx(base.cabecalhoSecao, centro && base.cabecalhoCentro, className)}>
      <span className={base.sobretitulo}>{sobretitulo}</span>
      <h2 className={base.titulo}>{titulo}</h2>
      {children && <p className={base.intro}>{children}</p>}
    </div>
  );
}
